export default "__VITE_PUBLIC_ASSET__d858a74b__"